import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';

import { AddDiagnosisComponent } from './components/add-diagnosis/add-diagnosis.component';
import { PatientShareDocumentsComponent } from './components/patient-share-documents/patient-share-documents.component';
import { PatientRetrieveDocumentsComponent } from './components/patient-retrieve-documents/patient-retrieve-documents.component';
import { ClientProfileComponent } from './components/clientprofile/clientprofile.component';
import { CreateadminComponent } from './components/createadmin/createadmincomponent';
import { CreateclientComponent } from './components/createclient/createclient.component';
import { CreatepatientComponent } from './components/createpatient/createpatient.component';
import { CreateuserComponent } from './components/createuser/createuser.component';
import { FacilityUserSelectionMockComponent } from './components/facility-user-selection-mock/facility-user-selection-mock.component';
import { FgpasswordComponent } from './components/fgpassword/fgpassword.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { MaintenancePageComponent } from './components/maintenance/maintenance.page';
import { MeetingsPageComponent } from './components/meetings-page/meetings-page.component';
import { PatientOverviewV2Component } from './components/patient-overview-v2/patient-overview-v2.component';
import { ReportComponent } from './components/report/report.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SearchComponent } from './components/search/search.component';
import { SetNewAccountPasswordComponent } from './components/set-new-account-password/set-new-account-password.component';
import { BffIntegrationTestComponent } from './studies/components/bff-integration-test/bff-integration-test.component';
import { StudiesPageComponent } from './studies/pages/studies-page/studies-page.component';
import { JoinPageComponent } from './components/join-page/join-page.component';
import { AuthGuardService } from './services/auth-guard.service';
import { PhiAccessAuditGuard } from './services/phi-access-audit.guard';
import { SuperuserGuard } from './guards/superuser.guard';
import { HubStaffGuard } from './guards/hub-staff.guard';
import { MergeCasesGuard } from './guards/merge-cases.guard';

const routes: Routes = [
  { component: LoginPageComponent, path: 'login' },
  { component: ResetPasswordComponent, path: 'validateEmail' },
  { component: SetNewAccountPasswordComponent, path: 'setnewaccountpassword' },
  { component: LoginPageComponent, path: 'login_eu' },
  { component: LoginPageComponent, path: 'login_eu/:sso' },
  { component: LoginPageComponent, path: 'login/:sso' },
  { component: LoginPageComponent, path: 'logout' },
  { component: CreateclientComponent, path: 'cclient' },
  { component: CreateuserComponent, path: 'cuser' },
  { component: CreateadminComponent, path: 'cadmin' },
  { component: FgpasswordComponent, path: 'fgpass' },
  { component: JoinPageComponent, path: 'join' },
  { component: CreatepatientComponent, path: 'cpatient', canActivate: [AuthGuardService, PhiAccessAuditGuard] },
  {
    component: SearchComponent,
    path: 'clients/:uid/:email/:realRole',
    canActivate: [AuthGuardService, PhiAccessAuditGuard]
  },
  {
    component: ClientProfileComponent,
    path: 'profile/:uid',
    canActivate: [AuthGuardService, PhiAccessAuditGuard]
  },
  // patient-profile route: URL only, component opens as dialog
  // This route exists to allow URL updates but doesn't render anything
  {
    component: HomePageComponent,
    path: 'patient-profile/:patientID',
    canActivate: [AuthGuardService, PhiAccessAuditGuard]
  },
  {
    component: PatientShareDocumentsComponent,
    path: 'patient-share-documents/:patientID',
    canActivate: [AuthGuardService, PhiAccessAuditGuard]
  },
  {
    component: PatientRetrieveDocumentsComponent,
    path: 'patient-retrieve-documents/:patientID',
    canActivate: [AuthGuardService, PhiAccessAuditGuard]
  },
  {
    component: AddDiagnosisComponent,
    canActivate: [AuthGuardService],
    path: 'add-diagnosis'
  },
  { component: HomePageComponent, path: 'comingsoon', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'admins', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'clients', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'clientsmatters/:type', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'feedlibrary', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'librarycategories', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'createclientmatter' },
  { component: HomePageComponent, path: 'createadminuser', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'createclientsmatters', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'attorneys_lawfirms' },
  { component: HomePageComponent, path: 'lpmwelcome' },
  { component: HomePageComponent, path: 'associates', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'owners', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'consultants', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'facilities', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'facilities-list', canActivate: [AuthGuardService] },
  { component: HomePageComponent, path: 'addsources', canActivate: [AuthGuardService] },
  { component: FacilityUserSelectionMockComponent, path: 'mock/facility-selection' },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/exchange/:facilityID/images/send',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/exchange/:facilityID/images/retreive',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/exchange/:facilityID/images',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/exchange/:facilityID/type',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/exchange/:facilityID',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/send-images',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/retrieve-images',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/send-documents',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/retrieve-documents',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName/exchange',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview/:caseName',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: PatientOverviewV2Component,
    path: 'patient-overview',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview' }
  },
  {
    component: HomePageComponent,
    path: 'patient-overview-modal/:caseName',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview Modal' }
  },
  {
    component: HomePageComponent,
    path: 'patient-overview-modal/:caseName/exchange',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview Modal' }
  },
  {
    component: HomePageComponent,
    path: 'patient-overview-modal/:caseName/exchange/:facilityID',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview Modal' }
  },
  {
    component: HomePageComponent,
    path: 'patient-overview-modal/:caseName/exchange/:facilityID/images',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview Modal' }
  },
  {
    component: HomePageComponent,
    path: 'patient-overview-modal/:caseName/exchange/:facilityID/images/retrieve',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Patient Overview Modal' }
  },
  {
    component: HomePageComponent,
    path: 'image-exchange/:patientId/from/:senderFacility/to/:targetFacility/images/retrieve',
    canActivate: [AuthGuardService, PhiAccessAuditGuard],
    data: { title: 'Image Exchange' }
  },
  {
    path: 'admin/network',
    loadChildren: () => import('./components/network-admin/network-admin.module').then(m => m.NetworkAdminModule),
    canActivate: [AuthGuardService, SuperuserGuard]
  },
  {
    path: 'admin/storage-report',
    loadChildren: () => import('./components/storage-report/storage-report.module').then(m => m.StorageReportModule),
    canActivate: [AuthGuardService, SuperuserGuard]
  },
  {
    path: 'hub/merge-cases',
    loadChildren: () => import('./components/hub-merge-cases/hub-merge-cases.module').then(m => m.HubMergeCasesModule),
    canActivate: [AuthGuardService, MergeCasesGuard]
  },
  {
    path: 'hub/usage',
    loadChildren: () => import('./components/usage-dashboard/usage-dashboard.module').then(m => m.UsageDashboardModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'hub/invitations',
    loadChildren: () => import('./components/hub-invitations/hub-invitations.module').then(m => m.HubInvitationsModule),
    canActivate: [AuthGuardService]
  },
  { component: HomePageComponent, path: '' },
  { component: ReportComponent, path: 'report/:uid', canActivate: [AuthGuardService, SuperuserGuard] },
  { component: MeetingsPageComponent, path: 'meetings', canActivate: [AuthGuardService] },
  { component: SearchComponent, path: 'clients', canActivate: [AuthGuardService] },
  { component: ResetPasswordComponent, path: 'resetpassword' },
];

if (environment.config.sysadmin) routes.push({
  path: 'sysadmin',
  loadChildren: () => import('./components/sysadmin/sysadmin.module').then(m => m.SysadminModule)
});
routes.push(
  { path: 'studies', component: StudiesPageComponent, canActivate: [AuthGuardService, PhiAccessAuditGuard] },
  { path: 'studies/test-integration', component: BffIntegrationTestComponent, canActivate: [AuthGuardService, PhiAccessAuditGuard] },
);
if (environment.maintenance) routes.push({ component: MaintenancePageComponent, path: '**' });
else routes.push({ component: HomePageComponent, path: '**' });

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
